import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4acc1807"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "talent-box" }
const _hoisted_2 = { class: "left animate__backInLeft wow" }
const _hoisted_3 = { class: "right animate__rotateIn wow" }
const _hoisted_4 = { class: "bottom" }
const _hoisted_5 = { alt: "" }

import WOW from 'wowjs'
import { onMounted, ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'talentView',
  setup(__props) {

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      justify: "space-around",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 15,
          sm: 15,
          md: 15,
          lg: 8,
          xl: 8
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('talenttext1')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('talenttext2')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 15,
          sm: 15,
          md: 15,
          lg: 16,
          xl: 16
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('talenttext3')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('talenttext4')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('talenttext5')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('talenttext6')), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      justify: "space-around",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                [_directive_lazy, require('@/assets/contact-talent.jpg')]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})